// @ts-nocheck

export type PropertyListWithRooms = typeof PropertyListWithRooms[keyof typeof PropertyListWithRooms];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyListWithRooms = {
  true: 'true',
  false: 'false',
} as const;
